import { StatusCode } from 'status-code-enum';
import type { ApiError } from '#~/api/index.js';

/** @internal */
export const getMessage = (code: ApiError['code']): string => {
  /* 404 */
  if (code === StatusCode.ClientErrorNotFound) {
    return "The agent you're trying to link cannot be found. Either the agent has already been linked or the url is incorrect. Please get a new link from your agent and try again.";
  }

  /* 412 */
  if (code === StatusCode.ClientErrorPreconditionFailed) {
    return "The link you're using has expired. Please get a new link from your agent and try again.";
  }

  return 'An unknown error occurred, please try again. If the problem persists, please get a new link from your agent.';
};
